/*@ngInject*/
const LoadRowInstanceListRepository = function (baseRepository, formRegistrationModel) {

    angular.extend(this, baseRepository);

    this.loadRowInstanceList = function (formId, registrationIdentifier) {
        let url = '/rest/FormRow/List?formId=' + formId + '&registrationIdentifier=' + registrationIdentifier;

        formRegistrationModel.addRegistration(formId, url);

        return this.get(url);
    };
};

angular.module('umFormViewer')
    .service('loadRowInstanceListRepository', LoadRowInstanceListRepository);
